import { useState, useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useDebounce } from 'use-debounce';
import { useNavigate } from 'react-router-dom';
import { useCompanySuggestions } from '@services/query.service';
import { Button, Search } from '@nazka/nazka.mapframe.components';
import { setVacancy } from '@App/pages/JobVacancy/job-vacancy.slice';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import Highlighter from 'react-highlight-words';

import theme from '@css/theme.style.json';

import './company-search.styl';

function DropDownOption(props) {
  const {
    highlighted, inputValue, 
    data: { address, company },
  } = props;

  return (
    <Button
      className="company-search__search__menu__item__button"
      css={{ backgroundColor: highlighted && theme.color.common.grey.xxlight }}
      hover={false}
      layout="ghost"
    >
      <Highlighter
        autoEscape
        highlightTag={Highlight}
        searchWords={inputValue?.split(' ')}
        textToHighlight={company}
      />
      <p>
        {address}
      </p>
    </Button>
  )
}

function Highlight({ children }) {
  return (
    <strong>
      {children}
    </strong>
  );
}

function CompanySearch() {
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [debouncedSearchValue] = useDebounce(searchValue, 300);
  
  const searchGeometry = useSelector(state => state.map.searchGeometry);
  const dispatch = useDispatch();

  const { data: companySuggestions, isLoading: isLoadingData } = useCompanySuggestions(debouncedSearchValue, searchGeometry);

  const options = useMemo(() => {
    if (!companySuggestions) return [];
    return companySuggestions.map((suggestion) => {
      return {
        id: suggestion.id,
        label: `${suggestion.label}: ${suggestion.address}`,
        data: { address: suggestion.address, company: suggestion.label },
      }
    })
  }, [companySuggestions]);
  
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(isLoadingData);
  }, [isLoadingData, options]);
  
  return (
    <div className="nav__search">
      <Search
        clear
        clearSearchInputOnBlur
        onSearch={setSearchValue}
        rootElProps={{
          onInput: (e) => {
            if (e.target.value.length >= 3) setIsLoading(true);
            else setIsLoading(false);
          },
        }}
        onSelect={(v) => {
          setValue(null);
          dispatch(setVacancy({ OIDN: v.id }));
          navigate(`/${v.id}`);
          window.gtag?.('event', 'vacancies_pro_lookup_company', {
            event_category: 'Vacancies',
            event_label: 'vacancies pro lookup company',
            OIDN: v.id,
          }); 
        }}
        value={value}
        options={options}
        customMenuItems={DropDownOption}
        width="200px"
        className="company-search__search"
        placeholder="Vind elk bedrijf in de zoekradius (ook zonder vacatures)"
        noResultsText={isLoading ? 'Bezig met zoeken...' : 'Geen bedrijf gevonden'}
        searchIcon={faSearch}
        isLoading={isLoading}
      />
    </div>
  )
}

export default CompanySearch;
